import { httpSingleton } from '@/lib/http-client';
import { AccountInviteModel } from '@/lib/models';

interface CreateInviteResponseBody {
	inviteToken: string;
}

interface AccountInviteResponseBody {
	accountId: string;
	accountStatusId: string;
	clientId: string;
	emailAddress: string;
	location: string | null;
	mobileNumber: string | null;
	name: string;
	timeZone: string;
	title: string | null;
}

interface GetInviteResponseBody extends AccountInviteModel {}

export const publicService = {
	authenticate(data: { emailAddress: string }) {
		// The backend sets the HttpOnly login token cookie
		return httpSingleton.orchestrateRequest<void>({
			method: 'POST',
			url: `/advisory-service/api/v1/public/authenticate`,
			data,
		});
	},
	createInvite(data: { name: string; emailAddress: string }) {
		return httpSingleton.orchestrateRequest<CreateInviteResponseBody>({
			method: 'POST',
			url: `/advisory-service/api/v1/public/create-invite`,
			data,
		});
	},
	getInvite(inviteId: string) {
		return httpSingleton.orchestrateRequest<GetInviteResponseBody>({
			method: 'GET',
			url: `/advisory-service/api/v1/public/account-invite/${inviteId}`,
		});
	},
	accountInvite(inviteId: string) {
		return httpSingleton.orchestrateRequest<AccountInviteResponseBody>({
			method: 'POST',
			url: `/advisory-service/api/v1/public/account-invite/${inviteId}`,
		});
	},
	getSystemStatus() {
		return httpSingleton.orchestrateRequest<{
			version: string;
			status: string;
			date: string;
		}>({
			method: 'GET',
			url: '/advisory-service/api/v1/public/system/status',
		});
	},
	getError() {
		return httpSingleton.orchestrateRequest<any>({
			method: 'GET',
			url: '/advisory-service/api/v1/public/system/error',
		});
	},
	// Sets the HttpOnly login token cookie. handOffToken is the ?X-Hackett-Access-Token= value from the auth UI
	// (or the local token with fake auth).
	createSession(handOffToken: string) {
		return httpSingleton.orchestrateRequest<void>({
			method: 'POST',
			url: '/advisory-service/api/v1/public/session',
			headers: {
				'Content-Type': 'text/plain',
			},
			data: handOffToken,
		});
	},
	// Signs out in the auth service and removes the login token cookie
	signOut() {
		return httpSingleton.orchestrateRequest<void>({
			method: 'POST',
			url: '/advisory-service/api/v1/public/session/sign-out',
		});
	},
};
